import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getCustomerWorkspaces, getWorkspace, getWorkspaces } from "@/api/resources/workspaces/api";
import { type CustomerWorkspaceAnalytics } from "@/api/resources/workspaces/types";
import i18n from "@/providers/i18n";

const entity = i18n.t("workspace");
const entityErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entity }),
};
const entities = i18n.t("workspaces");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const workspacesQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "workspaces"],
  lists: () => [...workspacesQueryKeys.all(), "list"],
  listAll: () => [...workspacesQueryKeys.lists(), "all"],
  listCustomerWorkspaces: (workspace_id?: string) => [
    ...workspacesQueryKeys.lists(),
    "customerWorkspaces",
    workspace_id,
  ],
  byId: (id?: string) => [...workspacesQueryKeys.all(), "byId", id],
};

export const workspacesQueries = {
  listAll: () =>
    queryOptions({
      queryKey: [...workspacesQueryKeys.listAll()],
      queryFn: () => getWorkspaces(),

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  listCustomerWorkspaces: (workspace_id?: string) =>
    queryOptions<CustomerWorkspaceAnalytics[]>({
      queryKey: [...workspacesQueryKeys.listCustomerWorkspaces(workspace_id)],
      queryFn: workspace_id ? () => getCustomerWorkspaces(workspace_id) : skipToken,

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  byId: (id?: string) =>
    queryOptions({
      queryKey: [...workspacesQueryKeys.byId(id)],
      queryFn: id ? () => getWorkspace({ id }) : skipToken,

      meta: {
        errorMessage: entityErrorMessage,
      },
    }),
};
